module.exports = __webpack_public_path__ + "static/media/map.394e6bff.svg";